import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";

export const ExplosionGroup = {
	"II A": "> 0.9",
	"II B(II B1)": "> 0.85 to ≤ 0.9",
	"II B(II B2)": "> 0.75 to ≤ 0.85",
	"II B(II B3)": "> 0.65 to ≤ 0.75",
	"II B": "> 0.5 to ≤ 0.65",
	"II C": "< 0.5",
};

export const ProductExplosionGroup = ({ value, onChange }: Omit<SelectProps<string, false>, "fetchOptions">) => {
	return <Select
		disableSearch
		fetchOptions={Object.keys(ExplosionGroup)}
		getOptionLabel={opt => ExplosionGroup[opt as keyof typeof ExplosionGroup]}
		value={value}
		onChange={onChange}
	/>;
};
